import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { searchAllBoards } from '../../api/boards';

export function useFolderPageCounts(workspaceId: string | undefined) {
  const { data: boards = [] } = useQuery({
    queryKey: ['page-sidebar-folder-counts', workspaceId ?? ''],
    queryFn: async () => {
      if (!workspaceId) {
        return [];
      }
      return searchAllBoards(workspaceId);
    },
    enabled: !!workspaceId,
    staleTime: 30000,
  });

  const folderPageCounts = useMemo(() => {
    const counts: Record<string, number> = {};

    boards.forEach((board) => {
      if (board.archived) {
        return;
      }

      const targetFolderIds = new Set<string>(
        (board.ancestorFolderIds || [])
          .filter((folderId): folderId is string => !!folderId && folderId !== 'root')
      );

      targetFolderIds.forEach((folderId) => {
        counts[folderId] = (counts[folderId] || 0) + 1;
      });
    });

    return counts;
  }, [boards]);

  const totalPageCount = useMemo(() => {
    return boards.filter((board) => !board.archived).length;
  }, [boards]);

  return { folderPageCounts, totalPageCount };
}
